var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: { title: _vm.$t("selectProduct"), hideRgtBtn: true, large: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-tabs",
              {
                attrs: { color: "transparent", "show-arrows": "" },
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c("v-tabs-slider", { attrs: { color: "primary" } }),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { attrs: { md3: "" } },
                      _vm._l(_vm.tabs, function(tabItem) {
                        return _c("v-tab", { key: tabItem }, [
                          _c("span", { staticClass: "tabItem" }, [
                            _vm._v(_vm._s(tabItem))
                          ])
                        ])
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { md4: "" } }),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      [
                        _vm.skus.size > 0
                          ? _c("v-checkbox", {
                              attrs: { label: _vm.$t("showAll") },
                              model: {
                                value: _vm.isShowAll,
                                callback: function($$v) {
                                  _vm.isShowAll = $$v
                                },
                                expression: "isShowAll"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      [
                        _c("v-checkbox", {
                          attrs: { label: _vm.$t("pinPopup") },
                          model: {
                            value: _vm.isKeptDialog,
                            callback: function($$v) {
                              _vm.isKeptDialog = $$v
                            },
                            expression: "isKeptDialog"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-tabs-items",
                  {
                    attrs: { touchless: "" },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  _vm._l(3, function(item, index) {
                    return _c(
                      "v-tab-item",
                      { key: "item" + index },
                      [
                        index === 0 && _vm.tab === 0
                          ? _c(
                              "v-container",
                              { attrs: { fluid: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-end": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", md2: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "append-icon": "filter_list",
                                            label: _vm.$t("search"),
                                            "single-line": "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.filter,
                                            callback: function($$v) {
                                              _vm.filter = $$v
                                            },
                                            expression: "filter"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-table", {
                                  staticClass: "my-1 levation-2 myDense",
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.products,
                                    search: _vm.filter,
                                    pagination: _vm.pagination,
                                    "rows-per-page-items": _vm.rowPerPage
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "subheading" },
                                              [_vm._v(_vm._s(props.index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c(
                                                  "v-layout",
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      { attrs: { md5: "" } },
                                                      [
                                                        _c("ProductWidget", {
                                                          attrs: {
                                                            name:
                                                              props.item.name,
                                                            condition:
                                                              props.item
                                                                .condition,
                                                            upc: props.item.upc,
                                                            asin:
                                                              props.item.asin,
                                                            isCombined:
                                                              props.item
                                                                .isCombined,
                                                            sku: props.item.sku
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.quantity)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [
                                                _c(
                                                  "v-layout",
                                                  { attrs: { row: "" } },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              dark: "",
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.showAddProductDialog(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Select")]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-flex",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              dark: "",
                                                              color: "primary",
                                                              flat: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.showEditProductDialog(
                                                                  props.item
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("Edit")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        index === 1 && _vm.tab === 1
                          ? _c(
                              "v-container",
                              { attrs: { fluid: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", md2: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            label: _vm.$t("users"),
                                            items: _vm.users,
                                            "item-text": "name",
                                            "item-value": "uid"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "item",
                                                fn: function(data) {
                                                  return [
                                                    _vm.isObject(data.item)
                                                      ? [
                                                          _c(
                                                            "v-list-tile-content",
                                                            {
                                                              domProps: {
                                                                textContent: _vm._s(
                                                                  data.item
                                                                )
                                                              }
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _c(
                                                            "v-list-tile-content",
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                [
                                                                  !data.item.uid
                                                                    ? _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "supervisor_account"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : [
                                                                        data
                                                                          .item
                                                                          .approvalType
                                                                          ? _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "perm_identity"
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              [
                                                                                _vm._v(
                                                                                  "local_shipping"
                                                                                )
                                                                              ]
                                                                            )
                                                                      ],
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        data
                                                                          .item
                                                                          .name
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ],
                                                                2
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.selectedUser,
                                            callback: function($$v) {
                                              _vm.selectedUser = $$v
                                            },
                                            expression: "selectedUser"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", md2: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "append-icon": "filter_list",
                                            label: _vm.$t("search"),
                                            "single-line": "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.filter,
                                            callback: function($$v) {
                                              _vm.filter = $$v
                                            },
                                            expression: "filter"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-table", {
                                  staticClass: "levation-2 myDense",
                                  attrs: {
                                    headers: _vm.headers,
                                    items: _vm.distribution,
                                    search: _vm.filter,
                                    pagination: _vm.pagination,
                                    "item-key": "fbmKey",
                                    "rows-per-page-items": _vm.rowPerPage
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "subheading" },
                                              [_vm._v(_vm._s(props.index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("ProductWidget", {
                                                  attrs: {
                                                    name: props.item.name,
                                                    condition:
                                                      props.item.condition,
                                                    upc: props.item.upc,
                                                    isCombined:
                                                      props.item.isCombined,
                                                    asin: props.item.asin,
                                                    sku: props.item.sku
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.userName)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.item.siteName)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.isHazmat &&
                                                _vm.validHazmatSite(
                                                  props.item.warehouseSite
                                                )
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          color: "orange",
                                                          "font-size": "16px"
                                                        },
                                                        attrs: {
                                                          title: _vm.$t(
                                                            "supportDangerousGoods"
                                                          )
                                                        }
                                                      },
                                                      [_vm._v("report_problem")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.quantity)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-right" },
                                              [
                                                _c(
                                                  "v-layout",
                                                  { attrs: { row: "" } },
                                                  [
                                                    _c(
                                                      "v-flex",
                                                      [
                                                        _vm.addedDistributionSet.has(
                                                          props.item.fbmKey
                                                        )
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "success",
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.$emit(
                                                                      "deleteDistribution",
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("Added")]
                                                            )
                                                          : _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  flat: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.addDistribution(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("Add")]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        index === 2 && _vm.tab === 2
                          ? _c(
                              "v-container",
                              { attrs: { fluid: "" } },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    attrs: {
                                      "justify-space-between": "",
                                      "align-center": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", md3: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            label: _vm.$t("warehouse"),
                                            items: _vm.warehouses,
                                            "item-text": "name",
                                            "item-value": "uid",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.selectedWarehouse,
                                            callback: function($$v) {
                                              _vm.selectedWarehouse = $$v
                                            },
                                            expression: "selectedWarehouse"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs8: "", md2: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "append-icon": "filter_list",
                                            label: _vm.$t("search"),
                                            "single-line": "",
                                            "hide-details": "",
                                            clearable: ""
                                          },
                                          model: {
                                            value: _vm.filter,
                                            callback: function($$v) {
                                              _vm.filter = $$v
                                            },
                                            expression: "filter"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "text-xs-right",
                                        attrs: { xs4: "", md2: "" }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              disabled:
                                                _vm.batchSelectedProducts
                                                  .length === 0
                                            },
                                            on: { click: _vm.batchAddProducts }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("add")) +
                                                " (" +
                                                _vm._s(
                                                  _vm.batchSelectedProducts
                                                    .length
                                                ) +
                                                ")\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-table", {
                                  staticClass: "my-1 levation-2 myDense",
                                  attrs: {
                                    headers: _vm.warehouseTabHeaders,
                                    items: _vm.warehouseDistribution,
                                    search: _vm.filter,
                                    pagination: _vm.pagination,
                                    "item-key": "fbmKey",
                                    "rows-per-page-items": _vm.rowPerPage
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      _vm.pagination = $event
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "items",
                                        fn: function(props) {
                                          return [
                                            _c(
                                              "td",
                                              { staticClass: "subheading" },
                                              [_vm._v(_vm._s(props.index + 1))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("v-checkbox", {
                                                  staticClass: "mt-0",
                                                  attrs: {
                                                    value: props.item.fbmKey,
                                                    "hide-details": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.batchSelectedProducts,
                                                    callback: function($$v) {
                                                      _vm.batchSelectedProducts = $$v
                                                    },
                                                    expression:
                                                      "batchSelectedProducts"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              [
                                                _c("ProductWidget", {
                                                  attrs: {
                                                    name: props.item.name,
                                                    condition:
                                                      props.item.condition,
                                                    upc: props.item.upc,
                                                    isCombined:
                                                      props.item.isCombined,
                                                    asin: props.item.asin,
                                                    sku: props.item.sku
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.userName)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(props.item.siteName)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.isHazmat &&
                                                _vm.validHazmatSite(
                                                  props.item.warehouseSite
                                                )
                                                  ? _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          color: "orange",
                                                          "font-size": "16px"
                                                        },
                                                        attrs: {
                                                          title: _vm.$t(
                                                            "supportDangerousGoods"
                                                          )
                                                        }
                                                      },
                                                      [_vm._v("report_problem")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-xs-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(props.item.quantity)
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.addProductDialog
              ? _c("InventoryDetails", {
                  attrs: {
                    title: _vm.$t("selectLocation"),
                    product: _vm.productInEdit,
                    addedDistributionSet: _vm.addedDistributionSet,
                    editMode: true,
                    skus: _vm.skus,
                    selectProductWarehouse: _vm.selectProductWarehouse,
                    allDistribution: _vm.distribution
                      .filter(function(item) {
                        return !item.isCombined
                      })
                      .concat(_vm.combinedUpcsByLocation),
                    isHazmat: _vm.isHazmat
                  },
                  on: {
                    deleteDistribution: function(item) {
                      return _vm.$emit("deleteDistribution", item)
                    },
                    addDistribution: function(item) {
                      return _vm.addDistribution(item)
                    }
                  },
                  model: {
                    value: _vm.addProductDialog,
                    callback: function($$v) {
                      _vm.addProductDialog = $$v
                    },
                    expression: "addProductDialog"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.editProductDialog
              ? _c("ProductEdit", {
                  attrs: {
                    title: _vm.$t("editProduct"),
                    actionFunc: _vm.editProduct,
                    product: _vm.productInEdit,
                    upcReadOnly: "",
                    editMode: true
                  },
                  model: {
                    value: _vm.editProductDialog,
                    callback: function($$v) {
                      _vm.editProductDialog = $$v
                    },
                    expression: "editProductDialog"
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e95656e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e95656e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddInventories.vue
// module id = null
// module chunks = 